import Button from "src/components/buttons/Button";

const Card = () => {
  return (
    <div className="p-[30px] flex flex-col justify-center gap-3 rounded-[10px] shadow-[0_0_4px_0_rgba(0,0,0,0.15)] w-[352px] max-h-fit">
      <div className="flex flex-col gap-[5px]">
        <div className="text-blue-dark text-base font-semibold">
          Billing Data
        </div>
        <div className="text-[11px] font-light leading-4 text-[#788087]">
          Lipsum generator: Lorem Ipsum - All the facts
        </div>
      </div>
      <div className="flex gap-[5px]">
        <Button
          text={"Export excel"}
          className="h-[30px] !rounded-[5px]"
          ghost
        />
        <Button
          text={"Export PDF"}
          className="h-[30px] !rounded-[5px]"
          primary
        />
      </div>
    </div>
  );
};

export default Card;
